<template>
  <v-card color="background" variant="flat" tile>
    <v-row>
      <v-col>
        <ImageCover
          :image-key="imageKey"
          :value="value"
          class="float-lg-left ma-2 mr-8"
          default-key="person_default_image"
          max-width="380"
          width="380"
          ><slot name="image-content" />
        </ImageCover>

        <v-card-text>
          <h2 class="text-h4 mb-2">About {{ value.name }}</h2>
          <h3 class="text-body-1 font-weight-bold mb-4">
            {{ value.title }}
          </h3>

          <div v-if="value.description">
            <!-- eslint-disable vue/no-v-html -->
            <div class="text-body-0" v-html="value.description"></div>
          </div>
        </v-card-text>
      </v-col>
    </v-row>

    <slot name="footer" />
  </v-card>
</template>

<script setup>
defineProps({
  href: {
    default: undefined,
    type: String
  },
  imageKey: {
    default: 'profile_image',
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
